import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, catchError, map, from, switchMap } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;

  constructor(private http: HttpClient, private globalService: GlobalServicesService) { }


  getSignedUrlGCS(payload: any, isCandidate?:boolean): Observable<HttpResponse<any>> {
    const headers = isCandidate 
      ? new HttpHeaders({ 'use-candidate-token': 'true' })
      : undefined;
    return this.http.post<HttpResponse<any>>(this.fast_api_url + '/gcs-signed-url', payload, {
      observe: 'response',
      ...(headers ? { headers } : {})
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  uploadUsingSignedUrlGCS(url: string, file: File): Observable<HttpEvent<any>> {
    return from(this.stripExif(file)).pipe(
      switchMap((strippedBlob) => {
        const sanitizedFile = new File(
          [strippedBlob],
          file.name,
          {
            type: file.type,
            lastModified: Date.now()
          }
        );
        
        const hasCustomHeader = url.includes('x-goog-meta-actual_name');
        let headers: HttpHeaders;
        
        if (hasCustomHeader) {
          headers = new HttpHeaders({
            'x-goog-meta-actual_name': sanitizedFile.name,
          });
        } else {
          headers = new HttpHeaders({
          });
        }
        
        return this.http.put(url, sanitizedFile, {
          headers: headers,
          reportProgress: true,
          observe: 'events'
        }).pipe(
          map(event => this.getEventMessage(event, sanitizedFile)),
          catchError(this.globalService.handleError.bind(this.globalService))
        );
      }),
      catchError(error => {
        const sanitizedFile = new File(
          [file],
          file.name,
          {
            type: file.type,
            lastModified: Date.now()
          }
        );
        
        const hasCustomHeader = url.includes('x-goog-meta-actual_name');
        let headers: HttpHeaders;
        
        if (hasCustomHeader) {
          headers = new HttpHeaders({
            'x-goog-meta-actual_name': sanitizedFile.name,
            'x-goog-meta-stripped': 'true',
          });
        } else {
          headers = new HttpHeaders({
            'x-goog-meta-stripped': 'true',
          });
        }
        
        return this.http.put(url, sanitizedFile, {
          headers: headers,
          reportProgress: true,
          observe: 'events'
        }).pipe(
          map(event => this.getEventMessage(event, sanitizedFile)),
          catchError(this.globalService.handleError.bind(this.globalService))
        );
      })
    );
  }

  private stripExif(file: File): Promise<Blob> {
    return new Promise((resolve, reject) => {
      if (file.type === 'image/svg+xml') {
        resolve(file as any);
        return;
      }
      if (!file.type.startsWith('image/')) {
        resolve(file as any);
        return;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0);

          canvas.toBlob((blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject('Canvas toBlob failed');
            }
          }, file.type, 0.95);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }
  
  private getEventMessage(event: HttpEvent<any>, file: File): any {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event);
      case HttpEventType.Response:
        return this.fileUploadSuccess(event, file);
      default:
        return { status: 'unknown', message: `Unexpected event type: ${event.type}` };
    }
  }
  
  private fileUploadProgress(event: HttpProgressEvent): any {
    const percentDone = event.total ? Math.round(100 * event.loaded / event.total) : 0;
    return { status: 'progress', message: `${percentDone}% uploaded.` };
  }
  
  private fileUploadSuccess(event: HttpResponse<any>, file: File): any {
    return { status: 'success', message: `File "${file.name}" was completely uploaded!`, body: event.body };
  }

  uploadUsingSignedUrl(url: string, payload: any) {
    return this.http.put(url, payload, { observe: 'events' });
  }

getFileByUrl(payload: any)
{
    return this.http.get(payload);
  }

  getSignedUrlBulkInvite(eventId: string, payload: any): Observable<any> {
    return this.http.post(`${this.fast_api_url}/events/${eventId}/candidates/bulk-invite`, payload);
  }  
  
}
